import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';
import { TopicLevel2StoreModel } from '../topic-level-2';

@Injectable({
  providedIn: 'root',
})
export class TopicLevel3HttpService extends SupabaseBaseHttpService<'topics_level_03', 'categories'> {
  readonly schema = 'categories';
  readonly tableName = 'topics_level_03';

  fetchByTopicLevel2Ids(ids: Array<TopicLevel2StoreModel['id']>) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .in('topic_level_02_id', ids)
        .throwOnError()
        .then((response) => response.data!),
    );
  }
}
